import { DataTableColumnHeader } from "@/components/ui/shadcn/DataTable/DataTableColumnHeader";
import { type FirmVirtualBusinessCard } from "@/lib/types/Firm";
import {
  formatAddress,
  formatLocalOrIntlPhoneNumber,
} from "@/lib/utils/format";
import { type ColumnDef, createColumnHelper } from "@tanstack/react-table";

const tableHelper = createColumnHelper<FirmVirtualBusinessCard>();
export const firmBusinessCardColumns: ColumnDef<FirmVirtualBusinessCard>[] = [
  tableHelper.accessor("fullName", {
    id: "Name",
    enableHiding: false,
    header: ({ column }) => <DataTableColumnHeader column={column} />,
  }),
  tableHelper.accessor("email", {
    id: "Email",
    header: ({ column }) => <DataTableColumnHeader column={column} />,
  }),
  tableHelper.accessor("phoneNumber", {
    id: "Phone Number",
    header: ({ column }) => <DataTableColumnHeader column={column} />,
    cell: ({ getValue }) => {
      const phoneNumber = getValue();
      return (
        formatLocalOrIntlPhoneNumber({ number: phoneNumber }) ||
        phoneNumber ||
        "-"
      );
    },
  }),
  tableHelper.accessor("website", {
    id: "Website",
    header: ({ column }) => <DataTableColumnHeader column={column} />,
    cell: ({ getValue }) => getValue() || "-",
  }),
  tableHelper.accessor("street1", {
    id: "Address",
    header: ({ column }) => <DataTableColumnHeader column={column} />,
    cell: ({ row }) => {
      const businessCard = row.original;
      const formattedAddress = formatAddress({
        street1: businessCard.street1,
        street2: businessCard.street2,
        city: businessCard.city,
        state: businessCard.state,
        zipCode: businessCard.zipCode,
        country: businessCard.country,
      });
      return formattedAddress || "-";
    },
  }),
] as ColumnDef<FirmVirtualBusinessCard>[];
